import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import AntdTable from '../../../components/table/AntdTable'
import { formatMessage, paginationInit, dateFormatYearMonthDayTime } from '../../../utils/common'
import { getTagReportLogList } from '../../../services/configuration/config'
// import { getSKUHistoryExport } from '../../../services/SendList/SendList'
import dayjs from 'dayjs'
const NfcUIDModalTable = props => {
  const commonStore = useSelector(state => state.commonStore)
  const [pagination] = useState(paginationInit)
  const [tableList, setTableList] = useState([])
  const [queryFlag] = useState(false)

  useEffect(() => {
    getTableList(props.productCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productCode])

  useEffect(() => {
    getTableList(props.productCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const getTableList = code => {
    const params = {
      tagUid: code,
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total
    }
    getTagReportLogList(params).then(res => {
      if (res.errorCode === '200') {
        let dt = res.resultData
        let resDt = dt.sort((a, b) => {
          return new Date(b.operationDate).getTime() - new Date(a.operationDate).getTime()
        })
        setTableList(resDt)
      }
    })
  }

  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.nfcUID'),
      dataIndex: 'tagUid'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.upc'),
      dataIndex: 'upc'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.plant'),
      dataIndex: 'plantCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.operation'),
      dataIndex: 'operation'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.operator'),
      dataIndex: 'operator'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.orderNumber'),
      dataIndex: 'orderNumber'
    },
    // {
    //   title: formatMessage(commonStore, 'languageObj.nfcUIDReport.apiDate'),
    //   dataIndex: 'apiDate',
    //   render: text => {
    //     return text ? dateTrans(text) : ''
    //   }
    // },
    // {
    //   title: formatMessage(commonStore, 'languageObj.nfcUIDReport.taggingDate'),
    //   dataIndex: 'taggingDate',
    //   render: text => {
    //     return text ? dateTrans(text) : ''
    //   }
    // },
    // {
    //   title: formatMessage(commonStore, 'languageObj.nfcUIDReport.sendDate'),
    //   dataIndex: 'sendAntDate',
    //   render: text => {
    //     return text ? dateTrans(text) : ''
    //   }
    // },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.operationDate'),
      dataIndex: 'operationDate',
      render: text => {
        return text ? dayjs(text).format(dateFormatYearMonthDayTime) : ''
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.status'),
      dataIndex: 'sendAntStatus'
    }
  ]

  return <AntdTable dataSource={tableList} columns={tableColumns} />
}
export default NfcUIDModalTable
